import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { usePayment } from "hooks/usePayment";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { ROUTES } from "routes/constants";

const PaymentInformationAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { paymentData } = usePayment();

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_PAYMENT);
        navigate(ROUTES.APPLICATION.PAYMENT);
    };

    return (
        <AccordionTemplate
            title="Payment Information"
            accordionName="your-review-information"
            onEdit={handleEdit}
            dataTestId="payment-information-accordion"
        >
            <div className="flex flex-col gap-2 mb-4">
                <p className="text-base-content text-sm font-semibold">Payment Method</p>
                <p className="text-base-content text-sm font-bold">
                    {paymentData?.paymentType === "CC" ? "Credit Card" : "Bank Transfer"}
                </p>
            </div>
            <div className="flex flex-col gap-2">
                <p className="text-base-content text-sm font-semibold">
                    {paymentData?.paymentType === "CC" ? "Card" : "Bank Account Number"}
                </p>
                <p className="text-base-content text-sm font-bold blur-upscope">
                    {paymentData?.paymentType === "CC"
                        ? `**** **** **** ${paymentData?.lastFourDigits}`
                        : `******${paymentData?.lastFourDigits}`}
                </p>
            </div>
        </AccordionTemplate>
    );
};

export default PaymentInformationAccordion;
